import { PropsWithChildren } from 'react';
import clsx from 'clsx';

import styles from './ModalYoutubeVideosIconButton.module.scss';

type ModalYoutubeVideosIconButtonProps = {
  onClick: () => void;
  className?: string;
} & PropsWithChildren;

const ModalYoutubeVideosIconButton = ({
  onClick,
  children,
  className
}: ModalYoutubeVideosIconButtonProps) => (
  <button type="button" className={clsx(styles.button, className)} onClick={onClick}>
    {children}
  </button>
);

export default ModalYoutubeVideosIconButton;
